import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import type { SeoResolved } from '@/lib/seo';
import { resolvePublicSeo } from '@/services/seo.service';

/**
 * Resolve metadados SEO da rota pública atual via API.
 * Em falha de rede devolve null (mantém fallback do index.html).
 */
export function usePageSeo(pathOverride?: string): {
  seo: SeoResolved | null;
  loading: boolean;
  path: string;
} {
  const location = useLocation();
  const path =
    pathOverride ??
    (location.pathname === '/' ? '/' : location.pathname.replace(/\/+$/, '') || '/');
  const [seo, setSeo] = useState<SeoResolved | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    resolvePublicSeo(path).then((data) => {
      if (cancelled) return;
      setSeo(data);
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, [path]);

  return { seo, loading, path };
}
